<template>
  <div>
    <p class="font-weight-bold mb-2">
      {{ $t('You have used') }} {{ questionsInfo.used_questions }}/{{ questionsInfo.limit_questions }} {{ $t('Questions') }}
    </p>
    <v-progress-linear
      :color="color"
      :value="questionsInfo.used_percentage"
      height="25"
    >
      <strong>{{ questionsInfo.used_percentage.toFixed(2) }}%</strong>
    </v-progress-linear>
    <v-alert
      v-if="questionsInfo.used_percentage >= 100"
      class="mt-4"
      type="info"
    >
      {{ $t("Upgrade your Team to create more questions!") }}
    </v-alert>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      showBasedOnUsedPercentage: {
        type: Boolean,
      },
      percentageLimit: {
        type: Number,
        required: false,
        default: 80
      },
      faqId: {
        type: Number,
        required: true
      },
    },

    data() {
      return {
        questionsInfo: {
          used_percentage: 0,
          used_questions: 0,
          limit_questions: 0
        }
      }
    },

    computed: {
      show() {
        if (! this.showBasedOnUsedPercentage) {
          return this.questionsInfo !== null;
        }

        return this.questionsInfo !== null && this.questionsInfo.used_percentage >= this.percentageLimit;
      },

      color() {
        const percentage = this.questionsInfo.used_percentage;
        if (percentage >= 80 && percentage < 95) {
          return 'amber';
        } else if (percentage >= 95) {
          return 'red';
        } else {
          return 'primary';
        }
      }
    },

    created() {
      this.getQuestionUsage();
    },

    methods: {
      getQuestionUsage() {
        axios.get(this.route('question-usage', [this.faqId]))
        .then(res => {
          this.questionsInfo = res.data;
        })
      }
    }
  }
</script>